import type {
  ClientChat,
  ClientPersonReference
} from '@DigitaleDoerfer/digitale-doerfer-api';

import { useAppState } from '@/features/authorization/provider/useAppState';
import { getChatPartner } from '@/features/chats/utils/chat';

export const useChatPartner = (
  chat?: ClientChat
): ClientPersonReference | undefined => {
  const { userId: ownUserId } = useAppState();
  return chat && getChatPartner(chat, ownUserId);
};
